<div *ngIf="containerDisplay === 'EMAILENTRY'" class="card blue">
    <div class="page-sub-title">Login</div>
    <form #form="ngForm" class="form">
        <div class="field">
            <input type="text" name="email" required [(ngModel)]="email" #emailModel="ngModel" name="email" placeholder=" " />
            <label>Email</label>
            <span class="error" *ngIf="emailModel.invalid && emailModel.touched">
                Email is required
            </span>
        </div>
        <button (click)="getAuthCodeOptions()">Next</button>
        <div class="error" *ngIf="showInvalidEmailMessage">
            The email provided does not match any existing accounts.
        </div>
    </form>
</div>

<div *ngIf="containerDisplay === 'DELIVERYMETHOD'" class="card">
    <div *ngIf="authCodeOptions?.canEmail && authCodeOptions?.canSMS">
        <div class="page-sub-title">How Should We Send Your Access Code?</div>
        <div class="card blue" (click)="setDeliveryMethod('EMAIL')">
            <div class="title">Email</div>
            <div><img src="../../../assets/noun-email-5561254-FFFFFF.png" class="delivery-method-icon" /></div>
            <p>Your access code will be sent to {{ authCodeOptions?.maskedEmail }}</p>
        </div>
        <div class="card blue" (click)="setDeliveryMethod('SMS')">
            <div class="title">Text</div>
            <div><img src="../../../assets/noun-text-message-5896126-FFFFFF.png" class="delivery-method-icon" /></div>
            <p>Your code will be sent the number ending in: {{ authCodeOptions?.phoneLast4 }}</p>
        </div>
    </div>
    <div *ngIf="authCodeOptions?.canEmail && !authCodeOptions?.canSMS">
    <div class="card blue" (click)="setDeliveryMethod('EMAIL')">
            <div><img src="../../../assets/noun-email-5561254-FFFFFF.png" class="delivery-method-icon" /></div>
            <p>Send my access code to {{ authCodeOptions?.maskedEmail }}</p>
        </div>
    </div>    
</div>

<div *ngIf="containerDisplay === 'CODEENTRY'" class="card blue codeentry">
    <div class="page-sub-title">Enter Your Access Code</div>
    <app-codeinput (codeInputComplete)="onCodeComplete($event)"></app-codeinput>
    <div class="error" *ngIf="showInvalidCodeMessage">
        Invalid Code
    </div>
</div>
